module.exports = __webpack_public_path__ + "img/garbage_clean.67170210.png";